import {
  NavigationBar,
  type NavigationBarIconName,
} from '@retailer-platform/shared-components/src/tds'

// L1 icon factories follow this pattern: outline glyph at rest, filled glyph
// when the L1 is the active section (own URL match for leaf L1s, any descendant
// match for expandable L1s). The active flag is supplied by `TdsNavigationBar`
// at render time. Use this helper instead of inlining the factory so the
// resting/active distinction stays uniform across all L1s.
export const tdsNavIcon =
  (name: NavigationBarIconName) =>
  ({ isActive }: { isActive?: boolean }) => (
    <NavigationBar.Icon name={name} variant={isActive ? 'filled' : 'outline'} />
  )
